// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-container {
    display: flex;
    gap: 8px;
    animation: fade-in 0.25s ease-out;
}

.message-container.user-message {
    justify-content: flex-end;
}

.message-container.ai-message {
    justify-content: flex-start;
    align-items: flex-end;
}

/* ── Avatar ───────────────────────────────────────────── */
.message-avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.ai-avatar {
    background: rgba(59, 130, 246, 0.1);
}

.ai-avatar svg {
    width: 14px;
    height: 14px;
    color: #3B82F6;
}

/* ── Bubbles ──────────────────────────────────────────── */
.message-bubble {
    max-width: 260px;
    padding: 10px 14px;
    border-radius: 16px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    word-break: break-word;
}

.user-bubble {
    background: #3B82F6;
    color: white;
    border-bottom-right-radius: 4px;
}

.ai-bubble {
    background: #f3f4f6;
    color: #1f2937;
    border-bottom-left-radius: 4px;
}

/* ── Text ─────────────────────────────────────────────── */
.message-text {
    font-size: 14px;
    line-height: 1.5;
    white-space: pre-wrap;
    margin: 0 0 4px 0;
    text-align: start;
    unicode-bidi: plaintext;
}

/* ── Timestamp ────────────────────────────────────────── */
.message-time {
    font-size: 11px;
    opacity: 0.55;
    margin-top: 2px;
}

.user-time {
    text-align: right;
}

.ai-time {
    text-align: left;
}

/* ── Animation ────────────────────────────────────────── */
@keyframes fade-in {
    from {
        opacity: 0;
        transform: translateY(6px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 480px) {
    .message-bubble {
        max-width: 200px;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/MessageBubble.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,QAAQ;IACR,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA,4DAA4D;AAC5D;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA,4DAA4D;AAC5D;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,8BAA8B;AAClC;;AAEA,4DAA4D;AAC5D;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA,4DAA4D;AAC5D;IACI,eAAe;IACf,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,4DAA4D;AAC5D;IACI;QACI,UAAU;QACV,0BAA0B;IAC9B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".message-container {\r\n    display: flex;\r\n    gap: 8px;\r\n    animation: fade-in 0.25s ease-out;\r\n}\r\n\r\n.message-container.user-message {\r\n    justify-content: flex-end;\r\n}\r\n\r\n.message-container.ai-message {\r\n    justify-content: flex-start;\r\n    align-items: flex-end;\r\n}\r\n\r\n/* ── Avatar ───────────────────────────────────────────── */\r\n.message-avatar {\r\n    width: 28px;\r\n    height: 28px;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.ai-avatar {\r\n    background: rgba(59, 130, 246, 0.1);\r\n}\r\n\r\n.ai-avatar svg {\r\n    width: 14px;\r\n    height: 14px;\r\n    color: #3B82F6;\r\n}\r\n\r\n/* ── Bubbles ──────────────────────────────────────────── */\r\n.message-bubble {\r\n    max-width: 260px;\r\n    padding: 10px 14px;\r\n    border-radius: 16px;\r\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);\r\n    word-break: break-word;\r\n}\r\n\r\n.user-bubble {\r\n    background: #3B82F6;\r\n    color: white;\r\n    border-bottom-right-radius: 4px;\r\n}\r\n\r\n.ai-bubble {\r\n    background: #f3f4f6;\r\n    color: #1f2937;\r\n    border-bottom-left-radius: 4px;\r\n}\r\n\r\n/* ── Text ─────────────────────────────────────────────── */\r\n.message-text {\r\n    font-size: 14px;\r\n    line-height: 1.5;\r\n    white-space: pre-wrap;\r\n    margin: 0 0 4px 0;\r\n    text-align: start;\r\n    unicode-bidi: plaintext;\r\n}\r\n\r\n/* ── Timestamp ────────────────────────────────────────── */\r\n.message-time {\r\n    font-size: 11px;\r\n    opacity: 0.55;\r\n    margin-top: 2px;\r\n}\r\n\r\n.user-time {\r\n    text-align: right;\r\n}\r\n\r\n.ai-time {\r\n    text-align: left;\r\n}\r\n\r\n/* ── Animation ────────────────────────────────────────── */\r\n@keyframes fade-in {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(6px);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .message-bubble {\r\n        max-width: 200px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
